import { RefmodelTypes } from '@/domain/refmodels/RefmodelTypes.enum';

const withCanFlyTo = (entity) => {
  if (!entity || !Object.hasOwnProperty.call(entity, 'entityType')) return entity;
  const { entityType } = entity;
  const canFlyTo = entityType !== RefmodelTypes.HelperFileType;
  return { ...entity, canFlyTo };
};

export { withCanFlyTo };